// Syft ACP - Core <https://github.com/Syft-Application/syft2acp>
// © Syft Online Limited

import * as types from './action-types'

export const fetchEmployerVenueNamesList = (employerID?: number) => {
  return { type: types.EMPLOYER_VENUE_NAMES_FETCH_BEGIN, employerID }
}
